import {createRoot} from 'react-dom/client'
import BoardHome from "./BoardHome";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {Board, Question} from "../javaTypes";

declare global {
    interface Window {
        board: Board,
        isAsker: boolean,
        isAnswerer: boolean,
        isBoardAdmin: boolean,
        isGK: boolean,
        questions: Question[],
        followedQuestions: string[],
        feedUrl: string
    }
}

const container = document.getElementById('reactContainer');
const queryClient = new QueryClient()
if(!container) {
    console.error("Mount point for runtime container not found")
} else {
    const root = createRoot(container);
    root.render(<QueryClientProvider client={queryClient}>
        <BoardHome board={window.board} isAsker={window.isAsker} isAdmin={window.isBoardAdmin} isGK={window.isGK}
                   isAnswerer={window.isAnswerer} questions={window.questions} followedQuestions={window.followedQuestions}
                   feedUrl={window.feedUrl} />
    </QueryClientProvider>);
}